<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="dbmSKU.pkId > 0 ? '编辑':'新建'"
      width="500px"
      top="10vh"
      @close="close()">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :model="dbmSKU"
        :rules="ruleValidate"
        class="form"
        label-width="100px">
      <el-form-item label="物料号" prop="materialNO">
        <el-input v-model="dbmSKU.materialNO" maxlength="30" :disabled="dbmSKU.pkid > 0" placeholder="请输入"/>
      </el-form-item>
      <el-form-item label="是否替代料" prop="alternative">
        <el-radio-group v-model="dbmSKU.alternative">
          <el-radio :label="false">否</el-radio>
          <el-radio :label="true">是</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="最大库存" prop="maxStock">
        <el-input v-model.number="dbmSKU.maxStock" placeholder="请输入"/>
      </el-form-item>
      <el-form-item label="最小库存" prop="minStock">
        <el-input v-model.number="dbmSKU.minStock" placeholder="请输入"/>
      </el-form-item>
      <el-form-item label="最小包装量" prop="minimumPackage">
        <el-input v-model.number="dbmSKU.minimumPackage" placeholder="请输入"/>
      </el-form-item>
      <el-form-item label="送货频次/天" prop="deliveryFrequency">
        <el-input v-model.number="dbmSKU.deliveryFrequency" placeholder="请输入"/>
      </el-form-item>
      <el-form-item label="采购周期/天" prop="procurementCycle">
        <el-input v-model.number="dbmSKU.procurementCycle" placeholder="请输入"/>
      </el-form-item>
      <el-form-item label="采购备注" prop="purchaseNote">
        <el-input v-model.number="dbmSKU.purchaseNote" placeholder="请输入"/>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible=false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    name: "MaterialDbmSkuEdit",
    components: {},
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        dbmSKU: {
          pkId: 0,
          materialNO: "",
          maxStock: null,
          minStock: null,
          minimumPackage: null,
          deliveryFrequency: null,
          procurementCycle: null,
          alternative: false,
        },
        ruleValidate: {
          materialNO: {required: true, message: "不能为空", trigger: "blur"},
          alternative: {required: true, message: "不能为空", trigger: "change"},
          maxStock: {required: true, type: "number", min: 0, message: "请输入大于等于0的数字", trigger: "blur"},
          minStock: {required: true, type: "number", min: 0, message: "请输入大于等于0的数字", trigger: "blur"},
          minimumPackage: {required: true, type: "number", min: 1, message: "请输入大于0的数字", trigger: "blur"},
          deliveryFrequency: {required: true, type: "number", min: 1, message: "请输入大于0的数字", trigger: "blur"},
          procurementCycle: {required: true, type: "number", min: 1, message: "请输入大于0的数字", trigger: "blur"},
        },
      };
    },
    methods: {
      open(id) {
        console.log(id);
        this.dbmSKU.pkId = id;
        this.dialogVisible = true;
        if (id > 0) {
          this.getData();
        }
      },
      getData() {
        this.contentLoading = true;
        this.$http
          .get("basic", `materialDbmSKUs/${this.dbmSKU.pkId}`)
          .then(resp => {
            this.dbmSKU = resp.data;
          })
          .finally(() => {
            this.contentLoading = false;
          });
      },

      close() {
        this.dialogVisible = false;
        this.$reset("form");
      },

      handleSubmit() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .save("basic", "materialDbmSKUs", this.dbmSKU)
              .then((resp) => {
                if (resp.success){
                  this.submitLoading = false;
                  this.dialogVisible = false;
                  this.$emit("save-success");
                  this.$message.success("保存成功");
                }
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
</style>
